// extracted by mini-css-extract-plugin
export default {"pagePanel":"Page_pagePanel__ct2Bh"};